module.exports = __webpack_public_path__ + "img/113.0df1acb6.jpg";